module.exports = __webpack_public_path__ + "media/2.98df27ec.mp3";